import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  graphContainer: {
    borderRadius: theme.radius.md,
    overflow: "hidden",
  },
}));
